import Link from "next/link";

import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";
import type { TRegistrationCardData } from "src/shared/types/globalStotre.types";

const PLATFORM_TERMS_URL = "https://www.attend.tech/terms-of-use";
const PLATFORM_PRIVACY_URL = "https://www.attend.tech/privacy-policy";

export const REGISTRATION_CARDS: TRegistrationCardData[] = [
  {
    title: "Upgrade Your Seats for Today's Game",
    description: (
      <>
        Make today&apos;s gameday experience even better with a complimentary
        seat upgrade. Log in using the email address associated with your
        tickets to view available upgrade options.
        <br />
        You must have a valid ticket to today&apos;s game to participate.
        Upgrades are for personal use only, may not be transferred or resold,
        and are subject to availability.
      </>
    ),
    buttonLabel: "View Available Upgrades",
    authRedirectPage: routes.home,
  },
];

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "Why don't I see seat upgrades available for purchase?",
    answer:
      "You must have a valid game ticket to today's game in order to participate in this exclusive opportunity. Offer valid for select seating areas.",
  },
  {
    question: "Will there be seat upgrades available for every game?",
    answer:
      "Upgrades are subject to availability. Please check prior to your game to view available upgrades.",
  },
  {
    question: "Can these tickets be transferred to a friend?",
    answer:
      "Upgrades purchased in connection with this program are for personal use only and may not be transferred or resold.",
  },
  {
    question: "Can my seats be changed?",
    answer:
      "After successful purchase, your tickets cannot be changed. Upgrade purchases are non-refundable.",
  },
];

export const TERMS_AND_CONDITION = () => (
  <>
    By checking the box you agree to receive notifications regarding your
    purchase and to the{" "}
    <Link target="_blank" href={PLATFORM_TERMS_URL}>
      Terms &amp; Conditions
    </Link>{" "}
    and{" "}
    <Link target="_blank" href={PLATFORM_PRIVACY_URL}>
      Privacy Policy
    </Link>
    . All sales are final. There are no refunds or exchanges.
  </>
);
